"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_react_1 = require("mobx-react");
var QuoteItemStore_1 = require("QuoteV2/Stores/QuoteItemStore");
var react_1 = __importDefault(require("react"));
var BemBuilder_1 = __importDefault(require("Utils/BemBuilder"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var Types_1 = require("@CommonFrontendBackend/Tokens/Types");
var ProductStaticWellKnownMapping_1 = require("@CommonFrontendBackend/QuoteV2/ProductStaticWellKnownMapping");
var Types_2 = require("@CommonFrontendBackend/QuoteV2/Types");
var c = (0, BemBuilder_1.default)("section");
var DiscountNotice = (function (_super) {
    __extends(DiscountNotice, _super);
    function DiscountNotice() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isZohoQuoteProductItem = function () {
            var _a, _b;
            var item = _this.props.item;
            return (item instanceof QuoteItemStore_1.QuoteProductItemStore &&
                [Types_1.ProviderType.Zoho.toString(), Types_1.ProviderType.Pipedrive.toString()].includes((_a = item.token.substitutionToken) === null || _a === void 0 ? void 0 : _a.providerType) &&
                ProductStaticWellKnownMapping_1.ProductStaticWellKnownMapping.supportsMappedProductField(Types_2.ProductMappedField.Discount, (_b = item.token.substitutionToken) === null || _b === void 0 ? void 0 : _b.id));
        };
        return _this;
    }
    DiscountNotice.prototype.render = function () {
        return (react_1.default.createElement(react_1.default.Fragment, null, this.isZohoQuoteProductItem() && (react_1.default.createElement(kaleidoscope_1.Text, { size: "xs", secondary: true, className: c("discount-note") }, "Discounts are visible after a page is created."))));
    };
    DiscountNotice = __decorate([
        mobx_react_1.observer
    ], DiscountNotice);
    return DiscountNotice;
}(react_1.default.Component));
exports.default = DiscountNotice;
